import { render, staticRenderFns } from "./NewAnalysis.vue?vue&type=template&id=f146cb1c&scoped=true"
import script from "./NewAnalysis.vue?vue&type=script&lang=ts"
export * from "./NewAnalysis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f146cb1c",
  null
  
)

export default component.exports